import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=278e4ffc&scoped=true&"
import script from "./NotificationsView.vue?vue&type=script&lang=js&"
export * from "./NotificationsView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=278e4ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e4ffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278e4ffc')) {
      api.createRecord('278e4ffc', component.options)
    } else {
      api.reload('278e4ffc', component.options)
    }
    module.hot.accept("./NotificationsView.vue?vue&type=template&id=278e4ffc&scoped=true&", function () {
      api.rerender('278e4ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifications/NotificationsView.vue"
export default component.exports